export default __webpack_public_path__ + "static/media/logo-cetic-35px.fb2bb4bd.png";